<span matTooltip="{{name()}} language" [matTooltipDisabled]="showName">
  <span *ngIf="showEmoji && emoji()">{{emoji()}}</span>
  <span *ngIf="showEmoji && emoji() && showAlpha2">{{' '}}</span>
  <span *ngIf="showAlpha2 || (showEmoji && !emoji() && !showName)" class="alpha2">{{alpha2.toUpperCase()}}</span>
  <span *ngIf="showName && (showEmoji || showAlpha2)">{{' '}}</span>
  <span *ngIf="showName">{{name()}}</span>
</span>
